import { usePopularCategories } from "src/hooks/usePopularCategories";
import { PopularCategory } from "src/types/graphql.d";
import { useRouter } from "next/router";
import { CategoryCard } from "src/molecules/CategoryCard";
import { localeFix } from "src/utils/genderLocale/genderLocale";
import { subGenderLocale } from "src/utils/genderLocale/subGenderLocale";
import styles from "./PopularCategories.module.scss";

function PopularCategories(): JSX.Element {
  const router = useRouter();
  const { slug: genderId, categories } = router.query;

  const popularCategoryGender =
    genderId && localeFix({ gender: genderId as string });

  const popularCategorySubGender =
    categories &&
    categories[0] &&
    subGenderLocale({
      subGender: categories[0],
    });

  const genderOrSubGender = (gdr: string, subGender: string) =>
    gdr === "kids" && subGender ? subGender : gdr;

  const popularCateogryGender = genderOrSubGender(
    popularCategoryGender as string,
    popularCategorySubGender as string
  );

  const { data } = usePopularCategories(popularCateogryGender);

  return (
    <div className={styles.wrapper}>
      {data &&
        data?.popularCategories?.map(
          (category: PopularCategory, index: number) => {
            return (
              <CategoryCard
                key={category.slug}
                category={category}
                link={`/${genderId as string}/${category.slug}`}
              />
            );
          }
        )}
    </div>
  );
}

export { PopularCategories };
